function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "communication_svg__a",
  x1: 9.75,
  y1: 7,
  x2: 12.386,
  y2: 13.028,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "communication_svg__b",
  x1: 9.75,
  y1: 11,
  x2: 12.386,
  y2: 17.028,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "communication_svg__c",
  x1: 9.75,
  y1: 15,
  x2: 12.386,
  y2: 21.028,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "communication_svg__d",
  x1: 8.438,
  y1: 19,
  x2: 11.763,
  y2: 23.943,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 3a4 4 0 00-4 4v21.131a1 1 0 001.555.832L9 26h16a4 4 0 004-4V7a4 4 0 00-4-4H7z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6 8a1 1 0 011-1h18a1 1 0 110 2H7a1 1 0 01-1-1z",
  fill: "url(#communication_svg__a)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6 12a1 1 0 011-1h18a1 1 0 110 2H7a1 1 0 01-1-1z",
  fill: "url(#communication_svg__b)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6 16a1 1 0 011-1h18a1 1 0 110 2H7a1 1 0 01-1-1z",
  fill: "url(#communication_svg__c)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6 20a1 1 0 011-1h11a1 1 0 110 2H7a1 1 0 01-1-1z",
  fill: "url(#communication_svg__d)"
});

var SvgCommunication = function SvgCommunication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default SvgCommunication;